/** Temporary desktop map-open tracer. Filter DevTools by `[MapDesktop]`. */
export function mapDesktopLog(
  step: string,
  data?: Record<string, unknown>,
) {
  if (typeof window === 'undefined') return
  console.log(`[MapDesktop] ${step}`, {
    at: new Date().toISOString(),
    ...data,
  })
}
